import * as $ from "jquery";
import {Decimal} from "decimal.js";
import {formatCurrency, showPriceWithCurrentCurrency} from 'Core/Currencies';
import {Notifications} from "Core/Notifications";
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {CartService} from "Components/Cart/CartService";
import {Step1Component} from 'Components/Cart/Step1/Step1';
import { Promotions } from "Components/Promotions";

export class CartCommon {

    public static isAllAjaxComplete : boolean = true;

    public static getDecimalFromHtmlElementValueOrDefault(val) {
        let quantity;
        try {
            quantity = new Decimal(val as number);
        } catch (e) {
            quantity = new Decimal(1);
        }
        return quantity;
    }

    public static extractCommonData(htmlElement) {
        let $this = $(htmlElement);
        let productId = $this.data('product-id');
        return {$this, productId}
    }

    public static extractFullCommonData(htmlInputElement)
    {
        let $this = $(htmlInputElement);
        let productId = $this.data('product-id');
        let quantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.val());
        let minQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.attr('min'));
        let maxQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.attr('max'));
        let step = $this.data('input-step');
        let unitIsFloat = CartCommon.getDecimalPlaces(parseFloat(step));

        return {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat}
    }

    public static extractRowCommonData(jqueryHtmlInputElement)
    {
        let row = jqueryHtmlInputElement.closest(Step1Selectors.PRODUCT_AND_OFFER_CART.CONTAINER);
        let price = row.data('product-price');
        let total = row.find(Step1Selectors.PRODUCT_AND_OFFER_CART.TOTAL);

        return {row, price, total}
    }

    public static changeProductQuantity(btnSelector, inputSelector, message) {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);

        if ($(btnSelector).data('quantity-control')) {
            if ($(btnSelector).data('quantity-control') == 'increase') {
                quantity = quantity.plus(step);
            } else {
                quantity = quantity.minus(step);
            }
            if (quantity.lessThanOrEqualTo(minQuantity)) {
                $this.val(minQuantity.toFixed(unitIsFloat));
                return false;
            }
            if (quantity.greaterThanOrEqualTo(maxQuantity)) {
                $this.val(maxQuantity.toFixed(unitIsFloat));
                Notifications.add(message, "info");
                return false;
            }
            $this.val(quantity.toFixed(unitIsFloat));
        }
    }

    public static focusoutProductPageProductQuantity(inputSelector, message) {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        if (quantity.lessThanOrEqualTo(minQuantity)) {
            $this.val(minQuantity.toFixed(unitIsFloat));
            return false;
        }
        if (quantity.greaterThanOrEqualTo(maxQuantity)) {
            $this.val(maxQuantity.toFixed(unitIsFloat));
            Notifications.add(message, "info");
            return false;
        }
        $this.val(quantity.toFixed(unitIsFloat));
    }

    public static inputKeyupHandler(inputSelector, event, message)
    {
        this.isAllAjaxComplete = false;
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        let {row, price, total} = CartCommon.extractRowCommonData($this);

        if (event.keyCode == 13) {
            return false;
        }

        if (quantity.greaterThanOrEqualTo(maxQuantity)) {
            Notifications.add(message, "info");
            quantity = maxQuantity;
            $this.val(quantity.toFixed(unitIsFloat));
        } else if (quantity.lessThanOrEqualTo(minQuantity)) {
            quantity = minQuantity;
            // $this.val(quantity.toFixed(unit_is_float));
        }

        let totalPrice = price * quantity.toNumber();

        total.text(formatCurrency(totalPrice));
        total.attr('data-total-price', totalPrice);

        CartService.update(productId, quantity.toNumber())
            .done($result => {
                const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
                Step1Component.handleDeliveryBarUpdate(pure_value, $result);
                Promotions.updateValues({
                    currentThresholdMin: $result.cartThreshold.currentThreshold,
                    currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
                    remainingAmount: $result.cartThreshold.missingAmount,
                    currentCartAmount: $result.cartThreshold.currentBasketAmount,
                    currentThresholdPercent: $result.cartThreshold.currentPercent,
                    nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
                    lastThresholdPercent: $result.cartThreshold.lastPercent
                });

                if ($result.cartThreshold.currentThreshold > 0) {
                    // then apply the promotion to total price
                    $(Step1Selectors.SUMMARY_PANEL.TOTAL)
                      .html(`
<s>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
<span style="color: green;">
    Razem po rabacie: <br> 
    <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
</span>
`);  
                }
            this.isAllAjaxComplete = true;
            })
    }

    public static inputFocusoutHandler(inputSelector)
    {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        let {row, price, total} = CartCommon.extractRowCommonData($this);

        if (quantity.lessThanOrEqualTo(minQuantity)) {
            quantity = minQuantity;
        }

        let quantityCorrectVal = quantity.toFixed(unitIsFloat);
        let totalPrice = price * quantityCorrectVal;

        $this.val(quantityCorrectVal);
        total.text(formatCurrency(totalPrice));
        total.attr('data-total-price', totalPrice);

        CartService.update(productId, quantityCorrectVal)
            .done($result => {
                const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
                Step1Component.handleDeliveryBarUpdate(pure_value, $result);
                Promotions.updateValues({
                    currentThresholdMin: $result.cartThreshold.currentThreshold,
                    currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
                    remainingAmount: $result.cartThreshold.missingAmount,
                    currentCartAmount: $result.cartThreshold.currentBasketAmount,
                    currentThresholdPercent: $result.cartThreshold.currentPercent,
                    nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
                    lastThresholdPercent: $result.cartThreshold.lastPercent
                });
                if ($result.cartThreshold.currentThreshold > 0) {
                    // then apply the promotion to total price
                    $(Step1Selectors.SUMMARY_PANEL.TOTAL)
                      .html(`
<s>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</s> <br>
<span style="color: green;">
Razem po rabacie: <br>
<b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
</span>
                    `);                       
                }
            })
    }

    public static calcTotalQuantities(allInputsSelector: string)
    {
        let totalQuantity = new Decimal(0);
        $(allInputsSelector).each(function (this) {
            // let tempQuantity = parseFloat($(this).val() as string);
            let tempQuantity;
            let unit = new Decimal(parseFloat($(this).attr('data-input-step')));

            if (unit.e == 0) {
                tempQuantity = new Decimal($(this).val() as number);
            } else {
                tempQuantity = new Decimal(1);
            }

            if (tempQuantity.isNaN()) {
                tempQuantity = new Decimal(1);
            }

            totalQuantity = totalQuantity.plus(tempQuantity);
            // ^ You cannot cast it to number initially because it will cause JQuery appending values one after another like 01234

        });
        $(Step1Selectors.SUMMARY_PANEL.TOTAL_QUANTITIES).text(totalQuantity.toString().replace(".", ","));
    }

    public static checkBasketLimit(selector, limit) {
        return CartCommon.productsInBasketCount(selector) + 1 > limit
    }

    public static productsInBasketCount(selector) {
        // Use first visible element since there may be multiple (mobile/desktop headers)
        const $el = $(selector).filter(':visible').first();
        if (!$el.length) {
            // Fallback to first element if none visible
            return parseInt($(selector).first().text()) || 0;
        }
        return parseInt($el.text()) || 0;
    }

    public static getDecimalPlaces(inputStep) {
        return (Number.isInteger(inputStep)) ? 0 : 2;
    }

    public static prepareResultValueAsFloat(text) {
        return parseFloat(text.replace(/&nbsp;/g, '').replace(',','.'))
    }
}import * as $ from "jquery";
import {Decimal} from "decimal.js";
import {formatCurrency, showPriceWithCurrentCurrency} from 'Core/Currencies';
import {Notifications} from "Core/Notifications";
import {Step1Selectors} from 'Components/Cart/Step1/Step1Selectors';
import {CartService} from "Components/Cart/CartService";
import {Step1Component} from 'Components/Cart/Step1/Step1';
import { Promotions } from "Components/Promotions";

export class CartCommon {

    public static isAllAjaxComplete : boolean = true;

    public static getDecimalFromHtmlElementValueOrDefault(val) {
        let quantity;
        try {
            quantity = new Decimal(val as number);
        } catch (e) {
            quantity = new Decimal(1);
        }
        return quantity;
    }

    public static extractCommonData(htmlElement) {
        let $this = $(htmlElement);
        let productId = $this.data('product-id');
        return {$this, productId}
    }

    public static extractFullCommonData(htmlInputElement)
    {
        let $this = $(htmlInputElement);
        let productId = $this.data('product-id');
        let quantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.val());
        let minQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.attr('min'));
        let maxQuantity = CartCommon.getDecimalFromHtmlElementValueOrDefault($this.attr('max'));
        let step = $this.data('input-step');
        let unitIsFloat = CartCommon.getDecimalPlaces(parseFloat(step));

        return {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat}
    }

    public static extractRowCommonData(jqueryHtmlInputElement)
    {
        let row = jqueryHtmlInputElement.closest(Step1Selectors.PRODUCT_AND_OFFER_CART.CONTAINER);
        let price = row.data('product-price');
        let total = row.find(Step1Selectors.PRODUCT_AND_OFFER_CART.TOTAL);

        return {row, price, total}
    }

    public static changeProductQuantity(btnSelector, inputSelector, message) {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);

        if ($(btnSelector).data('quantity-control')) {
            if ($(btnSelector).data('quantity-control') == 'increase') {
                quantity = quantity.plus(step);
            } else {
                quantity = quantity.minus(step);
            }
            if (quantity.lessThanOrEqualTo(minQuantity)) {
                $this.val(minQuantity.toFixed(unitIsFloat));
                return false;
            }
            if (quantity.greaterThanOrEqualTo(maxQuantity)) {
                $this.val(maxQuantity.toFixed(unitIsFloat));
                Notifications.add(message, "info");
                return false;
            }
            $this.val(quantity.toFixed(unitIsFloat));
        }
    }

    public static focusoutProductPageProductQuantity(inputSelector, message) {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        if (quantity.lessThanOrEqualTo(minQuantity)) {
            $this.val(minQuantity.toFixed(unitIsFloat));
            return false;
        }
        if (quantity.greaterThanOrEqualTo(maxQuantity)) {
            $this.val(maxQuantity.toFixed(unitIsFloat));
            Notifications.add(message, "info");
            return false;
        }
        $this.val(quantity.toFixed(unitIsFloat));
    }

    public static inputKeyupHandler(inputSelector, event, message)
    {
        this.isAllAjaxComplete = false;
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        let {row, price, total} = CartCommon.extractRowCommonData($this);

        if (event.keyCode == 13) {
            return false;
        }

        if (quantity.greaterThanOrEqualTo(maxQuantity)) {
            Notifications.add(message, "info");
            quantity = maxQuantity;
            $this.val(quantity.toFixed(unitIsFloat));
        } else if (quantity.lessThanOrEqualTo(minQuantity)) {
            quantity = minQuantity;
            // $this.val(quantity.toFixed(unit_is_float));
        }

        let totalPrice = price * quantity.toNumber();

        total.text(formatCurrency(totalPrice));
        total.attr('data-total-price', totalPrice);

        CartService.update(productId, quantity.toNumber())
            .done($result => {
                const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
                Step1Component.handleDeliveryBarUpdate(pure_value, $result);
                Promotions.updateValues({
                    currentThresholdMin: $result.cartThreshold.currentThreshold,
                    currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
                    remainingAmount: $result.cartThreshold.missingAmount,
                    currentCartAmount: $result.cartThreshold.currentBasketAmount,
                    currentThresholdPercent: $result.cartThreshold.currentPercent,
                    nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
                    lastThresholdPercent: $result.cartThreshold.lastPercent
                });

                if ($result.cartThreshold.currentThreshold > 0) {
                    // then apply the promotion to total price
                    $(Step1Selectors.SUMMARY_PANEL.TOTAL)
                      .html(`
<s>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
<span style="color: green;">
    Razem po rabacie: <br> 
    <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
</span>
`);  
                }
            this.isAllAjaxComplete = true;
            })
    }

    public static inputFocusoutHandler(inputSelector)
    {
        let  {$this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat} = CartCommon.extractFullCommonData(inputSelector);
        let {row, price, total} = CartCommon.extractRowCommonData($this);

        if (quantity.lessThanOrEqualTo(minQuantity)) {
            quantity = minQuantity;
        }

        let quantityCorrectVal = quantity.toFixed(unitIsFloat);
        let totalPrice = price * quantityCorrectVal;

        $this.val(quantityCorrectVal);
        total.text(formatCurrency(totalPrice));
        total.attr('data-total-price', totalPrice);

        CartService.update(productId, quantityCorrectVal)
            .done($result => {
                const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).html(String($result.value.total));
                $(Step1Selectors.SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
                Step1Component.handleDeliveryBarUpdate(pure_value, $result);
                Promotions.updateValues({
                    currentThresholdMin: $result.cartThreshold.currentThreshold,
                    currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
                    remainingAmount: $result.cartThreshold.missingAmount,
                    currentCartAmount: $result.cartThreshold.currentBasketAmount,
                    currentThresholdPercent: $result.cartThreshold.currentPercent,
                    nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
                    lastThresholdPercent: $result.cartThreshold.lastPercent
                });
                if ($result.cartThreshold.currentThreshold > 0) {
                    // then apply the promotion to total price
                    $(Step1Selectors.SUMMARY_PANEL.TOTAL)
                      .html(`
<s>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</s> <br>
<span style="color: green;">
Razem po rabacie: <br>
<b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
</span>
                    `);                       
                }
            })
    }

    public static calcTotalQuantities(allInputsSelector: string)
    {
        let totalQuantity = new Decimal(0);
        $(allInputsSelector).each(function (this) {
            // let tempQuantity = parseFloat($(this).val() as string);
            let tempQuantity;
            let unit = new Decimal(parseFloat($(this).attr('data-input-step')));

            if (unit.e == 0) {
                tempQuantity = new Decimal($(this).val() as number);
            } else {
                tempQuantity = new Decimal(1);
            }

            if (tempQuantity.isNaN()) {
                tempQuantity = new Decimal(1);
            }

            totalQuantity = totalQuantity.plus(tempQuantity);
            // ^ You cannot cast it to number initially because it will cause JQuery appending values one after another like 01234

        });
        $(Step1Selectors.SUMMARY_PANEL.TOTAL_QUANTITIES).text(totalQuantity.toString().replace(".", ","));
    }

    public static checkBasketLimit(selector, limit) {
        return CartCommon.productsInBasketCount(selector) + 1 > limit
    }

    public static productsInBasketCount(selector) {
        // Use first visible element since there may be multiple (mobile/desktop headers)
        const $el = $(selector).filter(':visible').first();
        if (!$el.length) {
            // Fallback to first element if none visible
            return parseInt($(selector).first().text()) || 0;
        }
        return parseInt($el.text()) || 0;
    }

    public static getDecimalPlaces(inputStep) {
        return (Number.isInteger(inputStep)) ? 0 : 2;
    }

    public static prepareResultValueAsFloat(text) {
        return parseFloat(text.replace(/&nbsp;/g, '').replace(',','.'))
    }
}